<app-restricted-state [heading]="eOrgChartMessages.RESTRICTED_TITLE" [message]="eOrgChartMessages.RESTRICTED_BODY"></app-restricted-state>
